module.exports = __webpack_public_path__ + "img/acFlow1.15065200.gif";